/**************************************************
 * Nombre: Seccion_Documentacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Documentacion_Informacion from "./Componentes/Documentacion_Informacion";
import Mision_Vision_Informacion from "./Componentes/Mision_Vision_Informacion";
import Portada_Documentacion from "./Componentes/Portada_Documentacion";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";
import {marcarEvento} from "../../Servicios/Analiticas/marcarEvento";

const Seccion_Documentacion = () => {

    useEffect(() => {
        marcarEvento('ver_documentacion')
        irArriba()
    }, []);
    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                <Portada_Documentacion/>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 0}}>
                <Documentacion_Informacion/>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 10, mb: 20}}>
                <Mision_Vision_Informacion/>
            </Grid2>

        </Grid2>
    )

}
export default Seccion_Documentacion;